import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const SELECTOR = {
  HTML: document.documentElement,
  HERO: document.querySelector('[data-hero]'),
  IMG: document.querySelector('[data-hero-img]'),
  LINES: [...document.querySelectorAll('[data-hero-line]')],
  HEADING_MAIN: document.querySelector('[data-hero-heading-main]'),
  HEADING_SUB: document.querySelector('[data-hero-heading-sub]'),
  COPY: document.querySelector('[data-hero-copy]'),
  RESERVE: document.querySelector('[data-reserve]'),
  NAV: document.querySelector('[data-nav-list]'),
  MENU_BUTTON: document.querySelector('[data-menu-btn]'),
}

const CLASSES = {
  LOADED: 'is-loaded',
}

export default class Hero {
  constructor() {
    if(!SELECTOR.HERO) return;


    const observer = new MutationObserver(records => {
      if (SELECTOR.HTML.className == CLASSES.LOADED) {
        this.opening();
        observer.disconnect()
      }
    })

    observer.observe(SELECTOR.HTML, {
      attributes: true,
      attributeFilter: ['class']
    })

  };

  opening() {
    const tl = gsap.timeline({
      defaults: {
        duration: 0.5,
        ease: 'none'
      }
    });

    gsap.fromTo(
      SELECTOR.IMG, {
        opacity: 0,
        scale: 1.15
      }, {
        opacity: 1,
        scale: 1,
        duration: 2.5
      }
    )

    tl.fromTo(
        SELECTOR.HEADING_MAIN, {
          opacity: 0,
          yPercent: 25
        }, {
          opacity: 1,
          yPercent: 0,
          duration: 0.75,
          ease: 'power2.out'
        }, '-=0.5'
      )
      .fromTo(
        SELECTOR.HEADING_SUB, {
          opacity: 0,
          yPercent: 25
        }, {
          opacity: 1,
          yPercent: 0,
          duration: 0.75,
          ease: 'power2.out'
        }, '-=0.4'
      )
      .fromTo(
        SELECTOR.RESERVE, {
          opacity: 0,
        }, {
          opacity: 1,
          duration: 0.75
        }, '-=0.75'
      )
      .fromTo(
        SELECTOR.COPY, {
          opacity: 0,
          yPercent: 25
        }, {
          opacity: 1,
          yPercent: 0,
          duration: 0.75,
          ease: 'power2.out'
        }, '-=0.5'
      )
      .fromTo(
        SELECTOR.NAV, {
          opacity: 0,
          xPercent: 50,
        }, {
          opacity: 1,
          xPercent: 0,
          duration: 0.75,
          ease: 'power2'
        }, '-=0.75'
      )
      .fromTo(
        SELECTOR.MENU_BUTTON, {
          opacity: 0,
        }, {
          opacity: 1,
          duration: 0.75,
          ease: 'power2'
        }, '-=0.1'
      )
  };
}